/**
 * Default predefined layouts for ShowcaseLayout component
 * Each layout is defined as [x, y, w, h] where:
 * - x: horizontal position (column)
 * - y: vertical position (row)
 * - w: width (columns)
 * - h: height (rows)
 */
export const defaultPredefinedLayouts: Array<[number, number, number, number]> =
  [
    [0, 0, 8, 16], // 0: [x, y, w, h]
    [8, 0, 2, 16], // 1: [x, y, w, h]
    [0, 31, 3, 8], // 2: [x, y, w, h]
    [0, 16, 3, 15], // 3: [x, y, w, h]
    [3, 16, 7, 7], // 4: [x, y, w, h]
    [3, 23, 7, 8], // 5: [x, y, w, h]
    [5, 31, 7, 6], // 6: [x, y, w, h]
    [3, 39, 7, 6], // 7: [x, y, w, h]
  ];
export const EXTERNAL_SLOT_START = 0; // First external slot index
export const EXTERNAL_SLOT_END = 7; // Last external slot index
